export const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] as const;

export const SLOT_HOURS = Array.from({ length: 24 }, (_, h) => h);

export const startOfDay = (d: Date) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

export const isSameDay = (a: Date, b: Date) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const toYmd = (d: Date) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const formatSlotLabel = (hour: number) => {
  const period = hour >= 12 ? "PM" : "AM";
  const h12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${h12}:00 ${period}`;
};

/** Full 1-hour window, e.g. "8:00 - 9:00". */
export const formatSlotRange = (hour: number) => {
  const start = hour;
  const end = (hour + 1) % 24;
  return `${start}:00 - ${end}:00`;
};

export const formatLongDay = (d: Date) =>
  d.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  });

export const formatMonthYear = (d: Date) =>
  d.toLocaleDateString("en-US", { month: "long", year: "numeric" });

export const getMonthCells = (viewMonth: Date) => {
  const year = viewMonth.getFullYear();
  const month = viewMonth.getMonth();
  const first = new Date(year, month, 1);
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const startPad = first.getDay();

  const cells: Array<{ date: Date; inMonth: boolean }> = [];

  for (let i = 0; i < startPad; i++) {
    cells.push({
      date: new Date(year, month, -startPad + i + 1),
      inMonth: false,
    });
  }

  for (let day = 1; day <= daysInMonth; day++) {
    cells.push({ date: new Date(year, month, day), inMonth: true });
  }

  while (cells.length % 7 !== 0) {
    const last = cells[cells.length - 1]!.date;
    const next = new Date(last);
    next.setDate(last.getDate() + 1);
    cells.push({ date: next, inMonth: false });
  }

  return cells;
};

export type DaySlotDto = {
  hour: number;
  bookedCount: number;
  capacity: number;
  available: boolean;
  myBooking: boolean;
  isPast: boolean;
  ist_date?: string;
  ist_hour?: number;
  ist_minute?: number;
  ist_label?: string;
  ist_range_24?: string;
  bookings?: Array<{
    id: number;
    lab_token: string;
    user_id: number;
    booked_by: string;
    booked_by_role: string;
    slot_date?: string;
    slot_hour?: number;
    slot_minute?: number;
    ist_label?: string | null;
    client_region?: string | null;
    client_local_date?: string | null;
    client_local_hour?: number | null;
    client_local_label?: string | null;
  }>;
};
